// extracted by mini-css-extract-plugin
module.exports = {"widget":"styles_widget__fhbw4"};